export { default as Icon, IconColor, IconName } from './icon';
